/**
 * Admin Portal Time API Client
 *
 * This file instantiates the time manipulation API client from the shared library
 * with the admin portal's axios instance.
 */
import { createTimeApi } from '@billda/shared-ui';
import { apiClient } from '../../../shared/api/axiosClient';

// Re-export types for convenience
export type {
  TimeResponse,
  AdvanceTimeRequest,
  AdvanceTimeResponse,
  TimeApi,
} from '@billda/shared-ui';

// Create and export the time API client with admin portal's axios instance
export const timeApi = createTimeApi(apiClient);
